import { Component } from "react";
import ProfileServices from "../../Services/ProfileServices";
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import { TableColumn } from "react-data-table-component";
import DataGrid from "../../Components/DataGrid/DataGrid";
import Swal from "sweetalert2";


interface IInvalidationData {
    userId: string,
    taxPayerName: string,
    email: string,
    phoneNumber: string
}

interface UserManagementState {
    accessToken: string;
    userData: IInvalidationData[],
    currentRowsPerPage: number,
    currentPage: number,
    totalRows: number,
    searchText: string,
    currentSortColumn: string,
    sortingDirection: string,

}

class InValidateForm8821 extends Component<{}, UserManagementState> {

    constructor(_props: any) {
        super(_props);
        this.state = {
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            userData: [],
            currentSortColumn: '',
            sortingDirection: ''

        }
    }

     private formColumns: TableColumn<IInvalidationData>[] = [
            {
                name: 'Taxpayer Name',
                selector: (row: IInvalidationData) => row.taxPayerName,
                sortable: true,
            },
            {
                name: 'Email',
                selector: (row: IInvalidationData) => row.email,
                sortable: true,
            },
    
            {
                name: 'Mobile Number',
                selector: (row: IInvalidationData) => row.phoneNumber,
                sortable: true,
    
            },
           
            {
                name: 'Action',
                cell: (row: IInvalidationData) => <button
                    className='Action-Btn'
                    onClick={(event) => {
                        this.invalidateForm8821(row);
                    }}>
                   Invalidate
                </button>,
                allowOverflow: false,
    
                button: true,
            },
            
        ];

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getInvalidationList();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    getInvalidationList() {

        let pageIndex: number = (this.state.currentPage - 1);
        let sortingObj: any = {};
        if (this.state.currentSortColumn != '') {
            sortingObj['column'] = this.state.currentSortColumn;
            sortingObj['direction'] = this.state.sortingDirection;
        }
        let pagination: any = {
            "offset": (pageIndex * this.state.currentRowsPerPage),
            "limit": this.state.currentRowsPerPage,
            "sort": { ...sortingObj },
            "searchFilter": this.state.searchText
        };

        ProfileServices.getInvaliadtionList(pagination, this.state.accessToken).then((r) => {
            if (r.ok) {
                r.json().then(resp => {
                    this.setState({ userData: resp.result, totalRows: resp.totalCount });
                });
            }
        });

    }


     invalidateForm8821(row: IInvalidationData) {
    
            let payload = {
                userId: row.userId,
                formName: 'form8821'
            };
            ProfileServices.updateInvalidateStatus(payload, this.state.accessToken).then((r) => {
                if (r.ok) {
                    r.json().then((resp) => {
                        this.getInvalidationList();
                        Swal.fire({
                            icon: "success",
                            title: "Success",
                            text: "Updated form invalidation status successfully",
                        });
                    });
                }
            });
    
        }

    identifySortingMapColumn(columnName: string) {
        let actualColName = '';
        switch (columnName) {
            case "Taxpayer Name":
                actualColName = 'taxPayerName';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Mobile Number":
                actualColName = 'phoneNumber';
                break;
        }
        return actualColName;
    }

    render() {
        return (<div className='body-sub-contianer table-container'>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    title='Invalidate Form-8821'
                    search='User Details'
                    columns={this.formColumns}
                    data={this.state.userData}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getInvalidationList();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        console.log(page, totalRows);
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getInvalidationList();
                        })
                    }}

                     onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                         this.setState({
                            currentPage: currentPage,
                            currentRowsPerPage: currentRowsPerPage
                        }, () => {
                            this.getInvalidationList();
                        })
                    }}
                    onSort={(column: any, direction) => {

                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1
                        }, () => {
                            this.getInvalidationList();
                        })
                    }}
                  
                    pagination
                    paginationTotalRows={this.state.totalRows}
                />
            </div>)
    }
}

export default InValidateForm8821;